import { render } from "./QuizType9.vue?vue&type=template&id=6a40db5c&scoped=true"
import script from "./QuizType9.vue?vue&type=script&lang=js"
export * from "./QuizType9.vue?vue&type=script&lang=js"

import "./QuizType9.vue?vue&type=style&index=0&id=6a40db5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a40db5c"]])

export default __exports__